// Modules
import { createSelector } from '@ngrx/store';

// Store - Reducers
import { AppState } from '@store/reducers';
import * as AuthReducer from '@store/reducers/auth.reducer';

export const selectAuthState = (state: AppState) => state.auth;

export const selectLoggedUser = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.loggedUser
);

export const selectLoginFailed = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.logingFailed
);

export const selectSigningInStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.signingIn
);

export const selectSigningOutStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.signingOut
);

export const selectPasswordRecoveredStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.passwordChanged
);

export const selectPasswordChangingStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.passwordChanging
);

export const selectPasswordRecoveringStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.passwordRecovering
);

export const selectPasswordRecoveryKeyStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.invalidPasswordReset
);

export const selectPasswordChangeErrorStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.passwordChangeError
);

export const selectPasswordChangeSuccessStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.passwordChangeSuccess
);

export const selectUserActivatingStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.userActivating
);

export const selectUserActivationStatus = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.invalidUserActivation
);

export const getConfigListadoRequested = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.getConfigListadoRequested
);

export const getConfigListadoResponse = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.getConfigListadoResponse
);

export const setConfigListadoRequested = createSelector(
  selectAuthState,
  (state: AuthReducer.AuthState) => state.setConfigListadoRequested
);
